var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kt-page-loader kt-page-loader--logo"},[_c('img',{attrs:{"alt":"Logo","src":_vm.logo}}),_c('div',{staticClass:"kt-spinner",class:_vm.spinnerClass || 'kt-spinner--brand'})])
}
var staticRenderFns = []

export { render, staticRenderFns }